import { useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useProvince() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = (county_id?: string) => {
    setLoading(true)

    api.get("/provinces/", {
      params: { county_id: county_id }
    }).then((res: SuccessFetch<{
      payload: {
        province_id: string
        province_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.province_name,
          value: item.province_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, refetch }
}